import templateUrl from "./resource-category-list.html";

export const resourcesCategoryListComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,

  controller: class ResourcesCategoryListComponent {
    constructor(
      $state,
      $stateParams,
      $scope,
      ModalService,
      resourcesService,
      toastr
    ) {
      "ngInject";
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.$scope = $scope;
      this.modalService = ModalService;
      this.resourcesService = resourcesService;
      this.toastr = toastr;
    }
    $onInit() {
      this.slug = this.$stateParams.slug;
      this.resourceVideoUrl =
        this.details.categoryDetails.value.videoUrl || null;
      this.resourceDetails = {
        data: this.details.categoryList,
        config: {
          defaultColumn: {
            columnName: "title", //default column name
            order: "DEF", //ASC = Ascending , DES = Descending, DEF = Default
          },
          columnDefs: [
            {
              field: "name",
              displayName: "TITLE",
              enableSort: true,
              isDownload: true,
              rowClass: "text-capitalize"
            },
            {
              field: "url",
              displayName: "URL",
              type: "",
              enableSort: false,
              isDownload: false,
            },
            {
              field: "edit",
              displayName: "",
              type: "Edit",
              enableSort: false,
            },
            {
              field: "delete",
              displayName: "",
              type: "Delete",
              enableSort: false,
            },
          ],
        },
      };
    }

    onLinkAdd() {
      this.$state.go("resourceCategoryVideoUrlAdd", { slug: this.slug });
    }

    onLinkEdit() {
      this.$state.go("resourceCategoryVideoUrlEdit", { slug: this.slug });
    }

    onLinkDelete() {
      this.modalService.open({
        details: {
          bodyMessage: "Are you sure to delete the video url ?",
        },
        buttons: [
          {
            name: "No",
            action() {},
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onLinkDelete.bind(this),
          },
        ],
      });
      function _onLinkDelete() {
        this.resourcesService
          .updateResourceVideoUrl(this.slug, { url: "" })
          .then((_) => {
            this.toastr.success("Video Url Deleted Successfully.");
            this.$state.reload();
          })
          .catch((err) => {
            this.toastr.error(err);
          });
      }
    }

    _onAddNewSubCategory() {
      this.$state.go("resourceSubCategoryAdd", { slug: this.slug });
    }

    _onDetailsCategory(id) {
      this.$state.go("resourceSubCategory", {
        id,
        resource_id: this.resourceId,
      });
    }

    _onEditCategory(id) {
      this.$state.go("resourceSubCategoryEdit", {
        slug: this.slug,
        id,
        resource_id: parseInt(this.resourceId),
      });
    }

    onEdit(resourceContent) {
      this.$state.go("resourceSubCategoryEdit", {
        slug: this.slug,
        id: resourceContent.id,
      });
    }
    onDelete(data) {
      this.deleteCategory(data.id);
    }
    deleteCategory(id) {
      this.modalService.open({
        details: {
          bodyMessage: "Are you sure you want to delete this category?",
        },
        buttons: [
          {
            name: "no",
          },
          {
            name: "yes",
            isPrimary: true,
            action: _delete.bind(this),
          },
        ],
      });
      function _delete() {
        this.resourcesService.deleteCategory(this.slug, id).then(
          () => {
            this.toastr.success("Category deleted successfully");
            this.$state.reload();
          },
          (errorDetails) => {}
        );
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/resources/resource-category/resource-category-list.component.js